import {MainComponent} from '@components/wiring-diagrams/main';
import {Layout} from '@components/layout/index';
import {DesktopMaxWidth} from '@components/widgets/Common';

export async function getStaticProps() {
  return {
    props: {
      paddingX: 'px-3',
      showFooterSignup: false,
      showCountdownTimerMobile: false
    }
  };
}

export default function IndexPage() {
  return (
    <DesktopMaxWidth>
      <MainComponent />
    </DesktopMaxWidth>
  );
}

IndexPage.Layout = Layout;
